<template lang="pug">
    .nestedTable(v-if="categories")
        .heading
            div.small
            div {{$t('tables.headings.categoryTitle')}}
            div.small
        row(:categoriesProp="categories" @reloadCategories="getCategories()" v-if="init")
</template>

<script>
import row from './row.vue';
import draggable from "vuedraggable";
export default {
    components : {
        row,
        draggable
    },
    data(){
        return {
            categories: null,
            init: true,
        }
    },
    created(){
        this.getCategories();
    },
    methods: {
        getCategories(){
            this.$axios.get('api/categories/getCategories')
                .then(axRes => {
                    this.categories = axRes.data;
                    this.init = false;
                    this.$nextTick(()=>{
                       this.init = true; 
                    })
                }).catch(axErr => {
                    this.showToast(this.$t('system.genericError'),
                        {
                            icon:'fa-warning',
                            position: 'bottom-right',
                            duration: 10000,
                            fullWidth: false,
                            className: 'vuestic-toast error'
                        })
                    })
        }
    }
}
</script>